export const svgCss = ({ theme }) => `
  font-size: 14px;
  font-weight: 500;
  font-family: ${theme.typography.fontFamily};
`;